const hostTenantMap: { [index: string]: any } = {
  'localhost:4200': '4200',
  'localhost:8080': '8080',
  'sysstorybookhmlstg.z13.web.core.windows.net': '4200',
  'sysstorybookprdstg.z13.web.core.windows.net': '8080',
};

export default hostTenantMap;
